export default "__VITE_ASSET__Bz55mpIq__"